import { render } from "./appointmentRecords.vue?vue&type=template&id=ce6859be&scoped=true"
import script from "./appointmentRecords.vue?vue&type=script&lang=js"
export * from "./appointmentRecords.vue?vue&type=script&lang=js"

import "./appointmentRecords.vue?vue&type=style&index=0&id=ce6859be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce6859be"]])

export default __exports__